import * as actionTypes from "../constants/actionTypes";

const resetModal = () => {
  return {
    type: actionTypes.RESET_MODAL
  };
};

const updateModal = (data, type) => {
  return {
    type: actionTypes.UPDATE_MODAL,
    data,
    modalType: type
  };
};

export { resetModal, updateModal };
